//

function _getGradeId(subject) {
  if (!subject.grades || !subject.grades.length) {
    return;
  }

  const sortedGrades = subject.grades.sort(function _sortGradesById(...args) {
    return new Date(args[0].id) - new Date(args[1].id);
  });

  return sortedGrades[0].id;
}

//

function sortSubjectsByDate(subjectA, subjectB) {
  const dateA = new Date(subjectA.updated_at);
  const dateB = new Date(subjectB.updated_at);

  if (dateB < dateA) {
    return -1;
  }
  if (dateB > dateA) {
    return 1;
  }

  return sortSubjectsByName(subjectA, subjectB);
}

//

function sortSubjectsByGrade(subjectA, subjectB) {
  const gradeA = _getGradeId(subjectA);
  const gradeB = _getGradeId(subjectB);

  if (gradeA < gradeB) {
    return -1;
  }
  if (gradeA > gradeB) {
    return 1;
  }

  return sortSubjectsByName(subjectA, subjectB);
}

//

function sortSubjectsByName(subjectA, subjectB) {
  const nameA = subjectA.subject_name.toLowerCase();
  const nameB = subjectB.subject_name.toLowerCase();

  if (nameA < nameB) {
    return -1;
  }
  if (nameA > nameB) {
    return 1;
  }

  return 0;
}

// Exports
// -------

export { sortSubjectsByDate, sortSubjectsByGrade, sortSubjectsByName };

export default sortSubjectsByGrade;
